import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import HeadingBeta from '../headings/heading-beta'

const HeadingLabel = props =>
  <div className={classNames('intro-title', props.className)}>
    {props.labelText
      ? <p className='label'>
          {props.labelText}
        </p>
      : null}
    <HeadingBeta>
      {props.titleText}
    </HeadingBeta>
  </div>

HeadingLabel.propTypes = {
  labelText: PropTypes.string,
  titleText: PropTypes.string
}

export default HeadingLabel



// WEBPACK FOOTER //
// ./src/ui/headings/heading-label.js